<script>
  import { onMount } from "svelte"
  import { push } from "svelte-spa-router"
  import { whenScreenTransitionFunc, targetWords } from "./stores.js"

  let page = 0
  let firstTargetWord = ""
  let secondTargetWord = ""

  onMount(async () => {
    whenScreenTransitionFunc()

    const unsubscribe = targetWords.subscribe((targetWordList) => {
      if (targetWordList && targetWordList.length > 0) {
        firstTargetWord = targetWordList[0].word || targetWordList[0].text || ""

        // ターゲット語の表示 最大5回探索
        const maxAttempts = Math.min(targetWordList.length, 5)
        for (let i = 1; i < maxAttempts; i++) {
          const candidate = targetWordList[i].word || targetWordList[i].text || ""
          if (candidate !== firstTargetWord) {
            secondTargetWord = candidate
            break
          }
        }

        // 見つからなかった場合は空文字
        if (!secondTargetWord) {
          secondTargetWord = ""
        }
      }
    })

    unsubscribe()
  })

  function clickNext() {
    if (page) {
      push("/test")
    } else {
      page = 1
    }
  }
</script>

<div class="wrapper">
  <div class="notebox">
    {#if !page}
      <p>
        「成功」「勝利」のように「良いこと」を表現（ひょうげん）する単語と「失敗」「敗北」のように「悪いこと」を表現する単語が画面に出てきます。
      </p>

      <p>
        「良いこと」を意味する単語が出たら ○
        にタッチ、「悪いこと」を意味する単語が出たら × にタッチしてください。
      </p>
    {:else}
      <p>
        くわえて「{firstTargetWord}」{#if secondTargetWord}「{secondTargetWord}」{/if}などの単語が出てきます。
      </p>

      <p>
        画面に出る指示（しじ）にしたがって、◯ または × をタッチしてください。
      </p>

      <p>できるだけ早く、しかもまちがえないようにタッチしてください。</p>

      <p>次へを押（お）して練習問題に進んでください</p>
    {/if}
  </div>

  <div class="next-button">
    <button class="indigo" on:click={clickNext}>次へ</button>
  </div>
</div>

<style lang="scss">
  .notebox {
    margin: 0 auto 2em auto;
    min-height: 40vh;
    margin-top: 8vh;
    max-width: 700px;
    padding: 2em 2em 1em 2em;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    text-align: left;
  }

  .notebox p {
    font-size: 1.2rem;
    line-height: 1.8;
    margin-bottom: 0;
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {
    .notebox {
      margin-top: 10vh;
      max-width: 700px;
      padding: 2em 2em 1em 2em;
    }
  }

  @media screen and (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    .notebox {
      margin-top: 8vh;
      max-width: 600px;
      padding: 2em 3em 1em 3em;
    }
    .notebox p {
      font-size: 1.1rem;
    }
  }
</style>
